import classNames from "classnames";
import PageContainer from "modules/components/PageContainer";
import Skeleton from "react-loading-skeleton";
import useScreenSize from "../../hoc/useScreenSize";
import styles from "./styles.module.scss";

function CategoryPagePlaceHolder() {
  const [isMobile] = useScreenSize();

  if (isMobile) {
    return (
      <PageContainer>

        <Skeleton height={38} count={1} />

        <Skeleton height={30} count={1} />

        <Skeleton height={100} count={1} />

        <Skeleton height={43} count={1} />

        <Skeleton height={45} count={3} />

        <Skeleton height={200} count={2} />
      </PageContainer>
    );
  }
  return (
    <PageContainer
      className={classNames(styles.flex_display, "row")}
      style={{ minHeight: "100%" }}
    >

      <div className="col-sm-4 col-md-3">

        <Skeleton count={3} />

        <Skeleton height={150} />

        <Skeleton height={650} />
      </div>

      <div className="col-sm-8 col-md-9 p-b-30" style={{ paddingRight: 0 }}>

        <Skeleton height={210} />

        <Skeleton height={70} />

        <Skeleton height={70} />

        <Skeleton height={180} count={4} />
      </div>
    </PageContainer>
  );
}

export default CategoryPagePlaceHolder;
